"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Col;
exports.getColumnProps = getColumnProps;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createProps = _interopRequireDefault(require("../../utils/createProps"));
var _types = require("../../utils/types");
var _excluded = ["tagName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  xs: _types.ColumnSizeType,
  sm: _types.ColumnSizeType,
  md: _types.ColumnSizeType,
  lg: _types.ColumnSizeType,
  xsOffset: _propTypes["default"].number,
  smOffset: _propTypes["default"].number,
  mdOffset: _propTypes["default"].number,
  lgOffset: _propTypes["default"].number,
  first: _types.ViewportSizeType,
  last: _types.ViewportSizeType,
  className: _propTypes["default"].string,
  tagName: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var classMap = {
  xs: 'col-xs',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg',
  xsOffset: 'col-xs-offset',
  smOffset: 'col-sm-offset',
  mdOffset: 'col-md-offset',
  lgOffset: 'col-lg-offset'
};
function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function getColClassNames(props) {
  var extraClasses = [];
  if (props.className) {
    extraClasses.push(props.className);
  }
  if (props.first) {
    extraClasses.push('first-' + props.first);
  }
  if (props.last) {
    extraClasses.push('last-' + props.last);
  }
  return Object.keys(props).filter(function (key) {
    return classMap[key];
  }).map(function (key) {
    return isInteger(props[key]) ? classMap[key] + '-' + props[key] : classMap[key];
  }).concat(extraClasses);
}
function getColumnProps(props) {
  return (0, _createProps["default"])(propTypes, props, getColClassNames(props));
}
function Col(props) {
  var tagName = props.tagName,
    columnProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(tagName || 'div', getColumnProps(columnProps));
}
Col.propTypes = propTypes;